import { ChangeEvent, useEffect, useState } from 'react'

import { SelectChangeEvent } from '@mui/material/Select'
import { AxiosResponse } from 'axios'
import { Card } from 'components'
import { useLoading, useModal, usePersistForm, useToggle } from 'hooks'
import {
  IPendingCre,
  ISearchPendingParams,
  ISearchPendingResponse,
  PendingCreServices
} from 'services/NGT/PendingCre'
import {
  IGetStatusOcupadoItems,
  IResponseGetStatusOcupado,
  WalletItemServices
} from 'services/NGT/Wallet'
import { SPACING } from 'utils'

import { ViewContractModal } from '../ViewContractModal/ViewContractModal'
import { FilterAnalyzePendingCre, TablePendingCre } from './components'
import { useForm } from 'react-hook-form'
import { string } from 'yup'
import { hasConnectionLostError } from 'services/Instances/utils'

const DEFAULT_PAGE = 1
const DEFAULT_ROWS_PER_PAGE = 15

interface OrdemPrioridadeSearchProps {
  nuBacklog: string
  nuBloqueio: string
  nuSubcontratacao: string
  nuDataAnexada: string
  ordemPrioridades: string[]
  pesquisGeralQuery: string
  firstGet?: boolean
}

const AnalyzePendingCre = () => {
  const { setLoading, setMsgErro } = useLoading()
  const { showModal, closeModal, showConnectionLostModal } = useModal()
  const [openViewContractModal, toggleViewContractModal] = useToggle()
  const [selectedContractId, setSelectedContractId] = useState(0)
  const [page, setPage] = useState<number>(DEFAULT_PAGE)
  const [rowsPerPage, setRowsPerPage] = useState<number>(DEFAULT_ROWS_PER_PAGE)
  const [totalItems, setTotalItems] = useState<number>(0)
  const [pendingCreTableData, setPendingCreTableData] = useState<IPendingCre[]>(
    []
  )

  const [clearButton, setClearButton] = useState(false)
  const [fazerPing, setFazerPing] = useState<number>(0)
  const [disponibilidadeCre, setDisponibilidadeCre] = useState<
    IGetStatusOcupadoItems[]
  >([])
  const [originalGetData, setOriginalGetData] = useState<IPendingCre[]>([])
  const [connLost, setConnLost] = useState<boolean>(false)
  const [isPesquisaGeral, setIsPesquisaGeral] = useToggle(false)
  const [stopPing, setStopPing] = useState<boolean>(false)

  const { watch, setValue, control, reset } =
    useForm<OrdemPrioridadeSearchProps>({
      defaultValues: {
        nuBacklog: null,
        nuBloqueio: null,
        nuDataAnexada: null,
        nuSubcontratacao: null,
        ordemPrioridades: [],
        pesquisGeralQuery: '',
        firstGet: true
      }
    })

  const ordemPrioridades = watch('ordemPrioridades')
  const pesquisGeralQuery = watch('pesquisGeralQuery')

  usePersistForm('ngt_ordem_prioridade', {
    setValue,
    watch
  })

  const handleViewContractModal = (contractId: number) => {
    setSelectedContractId(contractId)
    toggleViewContractModal()
  }

  const handleChangeOrdemPrioridades = (event: SelectChangeEvent) => {
    const {
      target: { value }
    } = event
    setValue(
      'ordemPrioridades',
      typeof value === 'string' ? value.split(',') : value
    )
  }

  const setPriorityStates = () => {
    ordemPrioridades.map((prioridade, index) => {
      if (prioridade === 'Backlog') {
        // setNuBacklog((index + 1).toString())
        setValue('nuBacklog', (index + 1).toString())
      }
      if (prioridade === 'Bloqueio') {
        setValue('nuBloqueio', (index + 1).toString())
        // setNuBloqueio((index + 1).toString())
      }
      if (prioridade === 'Subcontratação') {
        setValue('nuSubcontratacao', (index + 1).toString())
        // setNuSubcontratacao((index + 1).toString())
      }
      if (prioridade === 'Data Anexada') {
        setValue('nuDataAnexada', (index + 1).toString())
        // setNuDataAnexada((index + 1).toString())
      }
    })
  }

  const handleChangePesquisaGeralQuery = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    setValue('pesquisGeralQuery', event.target.value)
  }

  const handleChangeSearchType = () => {
    setIsPesquisaGeral(!isPesquisaGeral)
    setPage(DEFAULT_PAGE)
    setRowsPerPage(DEFAULT_ROWS_PER_PAGE)
  }

  const handlePesquisaGeral = () => {
    setLoading('loading')

    if (!isPesquisaGeral) {
      handleChangeSearchType()
    }

    PendingCreServices()
      .generalSearch(pesquisGeralQuery, rowsPerPage, page)
      .then(({ data, status }) => {
        if (status !== 200) {
          setMsgErro('Não foi possível obter os resultados da pesquisa')
          setLoading('error')
          return
        }

        setPendingCreTableData(data.items)
        setOriginalGetData(data.items)
        setTotalItems(data.pageCount)
        setValue('firstGet', false)
        setLoading('idle')
      })
      .catch(() => {
        // setMsgErro('Não foi possível obter os resultados da pesquisa')
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os resultados da pesquisa',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleClearButton = () => {
    reset()
    setClearButton(true)
  }

  const handleOnClickSearch = () => {
    if (page == 1) {
      handleSearch()
    }
    setPage(1)
  }

  const handleSearchPendingCre = async () => {
    setLoading('loading')

    try {
      if (isPesquisaGeral) {
        handleChangeSearchType()
      }

      await setPriorityStates()

      const requestQUERY: ISearchPendingParams = {
        NuBacklog: watch('nuBacklog'),
        NuBloqueio: watch('nuBloqueio'),
        NuDataAnexada: watch('nuDataAnexada'),
        NuSubcontratacao: watch('nuSubcontratacao'),
        QuerySearch: watch('pesquisGeralQuery'),
        pageNumber: page,
        pageSize: rowsPerPage
      }

      await PendingCreServices()
        .getPendencia(requestQUERY)
        .then((response) => {
          if (response.status !== 200) {
            throw new Error(response.statusText)
          }

          setPendingCreTableData(response.data.items)
          setTotalItems(response.data.pageCount)
          setOriginalGetData(response.data.items)
          setValue('nuBacklog', null)
          setValue('nuBloqueio', null)
          setValue('nuDataAnexada', null)
          setValue('nuSubcontratacao', null)
          setValue('firstGet', false)
          setLoading('idle')
        })
    } catch (error: any) {
      setMsgErro('Não foi possível obter os resultados da pesquisa')
      setLoading('error')
    }
  }

  useEffect(() => {
    setPriorityStates()
  }, [ordemPrioridades])

  useEffect(() => {
    if (clearButton) {
      if (page == 1) {
        handleSearchPendingCre()
      } else {
        setPage(1)
      }
      setClearButton(false)
    }
  }, [clearButton])

  const handleSearch = () => {
    if (isPesquisaGeral) {
      handlePesquisaGeral()
      return
    }
    handleSearchPendingCre()
  }

  const VerificarDisponibilidadeCRE = async () => {
    const idCreList: number[] = pendingCreTableData?.map(
      (item: IPendingCre) => item.idCre
    )

    if (stopPing && !hasConnectionLostError()) setStopPing(false)

    setTimeout(() => {
      setFazerPing(fazerPing + 1)
    }, 6000)

    if (idCreList.length > 0 && !stopPing) {
      try {
        const response: AxiosResponse<IResponseGetStatusOcupado> =
          await WalletItemServices().verificarDisponibilidadeCre(idCreList)

        if (response.data.sucesso) {
          setDisponibilidadeCre(response.data.entity)
          if (connLost) {
            showModal({
              hideButtonCancel: true,
              message: 'Conexão do servidor reestabelecida',
              titleModal: 'OK',
              txtButtonConfirm: 'Fechar',
              type: 'success'
            })
            setConnLost(false)
          }
        } else if (response.status === 400) {
          return
        } else {
          throw new Error(
            response.data.mensagem ||
              'Ocorreu um erro ao verificar disponibilidade dos Contratos'
          )
        }
      } catch (error: any) {
        if (connLost) return
        if (hasConnectionLostError()) {
          setStopPing(true)
          showConnectionLostModal()
          return
        }
        if (error?.status == 400) setConnLost(true)
        showModal({
          hideButtonCancel: true,
          message:
            error.message ||
            error.messagem ||
            'Ocorreu um erro ao verificar disponibilidade do CRE',
          titleModal: 'Alerta',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
      }
    }
  }

  useEffect(() => {
    VerificarDisponibilidadeCRE()
  }, [fazerPing])

  useEffect(() => {
    if (disponibilidadeCre.length == pendingCreTableData.length) {
      const newTableData: IPendingCre[] = pendingCreTableData.map(
        (item: IPendingCre, index: number) => {
          if (
            item.idCre === disponibilidadeCre[index].idCre &&
            disponibilidadeCre[index].creOcupado
          ) {
            return {
              ...item,
              cdCodigoCre: disponibilidadeCre[index].codigoCRE,
              flEmAnalise: disponibilidadeCre[index].creOcupado,
              nmAnalista: disponibilidadeCre[index].nomeAnalista,
              txStatusColor: disponibilidadeCre[index].status
            }
          } else if (
            item.idCre === disponibilidadeCre[index].idCre &&
            !disponibilidadeCre[index].creOcupado
          ) {
            return {
              ...item,
              cdCodigoCre: originalGetData[index].cdCodigoCre,
              flEmAnalise: originalGetData[index].flEmAnalise,
              nmAnalista: originalGetData[index].nmAnalista,
              txStatusColor: originalGetData[index].txStatusColor
            }
          } else {
            return item
          }
        }
      )
      setPendingCreTableData(newTableData)
    }
  }, [disponibilidadeCre])

  useEffect(() => {
    if (!watch('firstGet')) {
      handleSearch()
    }
  }, [rowsPerPage, page])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <FilterAnalyzePendingCre
          setPesquisaGeralSearchQuery={handleChangePesquisaGeralQuery}
          pesquisaGeralSearchQuery={pesquisGeralQuery}
          handlePesquisaGeral={handleOnClickSearch}
          ordemPrioridades={ordemPrioridades}
          handleChangeOrdemPrioridades={handleChangeOrdemPrioridades}
          handleClearButton={handleClearButton}
          handleSearchPendingCre={handleOnClickSearch}
        />
        <TablePendingCre
          tableData={pendingCreTableData}
          totalItems={totalItems}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          selectedContractInfo={handleViewContractModal}
        />
      </Card>
      <ViewContractModal
        showModal={openViewContractModal}
        toggleModal={toggleViewContractModal}
        contractID={selectedContractId}
      />
    </>
  )
}

export default AnalyzePendingCre
